import { useState, useCallback } from 'react';

/**
 * 렌더링을 강제하는 함수를 반환한다
 */
export const useForceRender = () => {
    const [renderCount, setRenderCount] = useState(0);

    const forceRender = useCallback(() => {
        setRenderCount((prev) => prev + 1);
    }, []);

    return forceRender;
};
